import React, { useCallback, useState, useEffect, useRef, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonBase } from "@material-ui/core";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from "react-router-dom";
import { PaginationComponent, Spinner, Tables, ViewTypes, TabsComponent, Inputs, SelectComponet } from '../../../../../../Components';
import { ActionsEnum, TableActions, UnitsFilterStatusEnum, ViewTypesEnum } from '../../../../../../Enums';
import { UnitsCardsComponent } from '../../../../UnitsSalesView/UnitsSalesUtilities/UnitsCardsComponent/UnitsCardsComponent.jsx';
import {
  UnitsAdvanceSearchTest,
} from '../../../../../../Services';
import { bottomBoxComponentUpdate, GetParams, GlobalHistory } from '../../../../../../Helper';
import { ActiveItemActions } from '../../../../../../store/ActiveItem/ActiveItemActions';
import { UnitMapper } from '../../../../UnitsSalesView/UnitMapper/UnitMapper.jsx';

export const PropertiesUnitsSale = ({
  operationType,
  viewType,
  onTypeChanged,
  parentTranslationPath,
  translationPath,
  createNewUnitHandler
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const location = useLocation();
  const searchTimer = useRef(null);
  const unitNumberInputRef = useRef(null);
  const [unitNumber, setUnitNumber] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [propertyId, setPropertyId] = useState(+GetParams('id'));

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState({
    pageSize: parseInt(localStorage.getItem('Pagination')) || 25,
    pageIndex: 0,
  });
  const [unitsDetailes, setUnitsDetailes] = useState({});
  const [sortBy, setSortBy] = useState(null);
  const orderFilter = useSelector((state) => state.GlobalOrderFilterReducer);
  const [selectedOrderBy, setSelectedOrderBy] = useState({
    filterBy: orderFilter.unitsSalesFilter.filterBy,
    orderBy: orderFilter.unitsSalesFilter.orderBy,
  });
  const [unitSearchType, setUnitSearchType] = useState(0);
  // Added filter states for sale units
  const [unitStatus, setUnitStatus] = useState([0]);
  const [unitPublishStatus, setUnitPublishStatus] = useState(0);
  const [bedrooms, setBedrooms] = useState("");
  const [bathrooms, setBathrooms] = useState("");
  const [orderBy, setOrderBy] = useState(
    selectedOrderBy.filterBy ? selectedOrderBy : { filterBy: "createdOn", orderBy: 2 }
  );
  const pathName = window.location.pathname
    .split('/home/')[1]
    .split('/view')[0]
    .split('/property-profile-edit')[0];
  useEffect(() => {
    setPropertyId(+GetParams('id'));
  }, [location]);


  const getPropertyUnits = useCallback(async (unitNumber) => {
    setIsLoading(true);

    let localFilterDto = {
      propertyId: [{ searchType: 1, value: propertyId }],
    };
    if (unitNumber) {
      localFilterDto = {
        ...localFilterDto,
        unit_number: [{ searchType: 1, value: unitNumber }],
      };
    }
    if (unitStatus && unitStatus.length && unitStatus[0] !== 0) {
      localFilterDto = {
        ...localFilterDto,
        status: unitStatus.map((status) => ({ searchType: 1, value: status })),
      };
    }
    if (unitPublishStatus && unitPublishStatus !== 0) {
      localFilterDto = {
        ...localFilterDto,
        publish_status: [{ searchType: 1, value: unitPublishStatus === 1 }],
      };
    }
    if (bedrooms && bedrooms !== "") {
      localFilterDto = {
        ...localFilterDto,
        bedrooms: [{ searchType: 2, value: bedrooms }],
      };
    }
    if (bathrooms && bathrooms !== "") {
      localFilterDto = {
        ...localFilterDto,
        bathrooms: [{ searchType: 2, value: bathrooms }],
      };
    }
    const body = {
      criteria: localFilterDto,
      operationType,
      ...orderBy,
    };

    const res = await UnitsAdvanceSearchTest(filter, body);
    if (!(res && res.status && res.status !== 200)) {
      setUnitsDetailes({
        result: ((res && res.result) || []).map((item) => item.unitJson && UnitMapper(item, JSON.parse(item.unitJson).unit)),
        totalCount: (res && res.totalCount) || 0,
      });
    }
    setIsLoading(false);
  }, [filter, propertyId, operationType, orderBy, unitStatus, unitPublishStatus, bedrooms, bathrooms]);

  const tableActionClicked = useCallback(
    (actionEnum, item) => {
      dispatch(ActiveItemActions.activeItemRequest(item));
      const unitOperationType = item && item.operation_type && item.operation_type.lookupItemName;
      const unitOperationTypeList = ['Sale', 'Rent', 'SaleAndRent'];

      if (actionEnum === TableActions.openFile.key) {
        if (unitOperationType === unitOperationTypeList[0]) {
          GlobalHistory.push(
            `/home/units-sales/unit-profile-edit?formType=${item.unitTypeId}&id=${item.id}`
          );
        } else if (unitOperationType === unitOperationTypeList[1]) {
          GlobalHistory.push(
            `/home/units-lease/unit-profile-edit?formType=${item.unitTypeId}&id=${item.id}`
          );
        } else if (unitOperationType === unitOperationTypeList[2]) {
          GlobalHistory.push(
            `/home/units-sales/unit-profile-edit?formType=${item.unitTypeId}&id=${item.id}`
          );
        } else {
          GlobalHistory.push(
            `/home/units/unit-profile-edit?formType=${item.unitTypeId}&id=${item.id}`
          );
        }
      }
    },
    [dispatch, pathName]
  );


  const detailedCardSideActionClicked = useCallback(
    (actionEnum, activeData) => async (event) => {
      dispatch(ActiveItemActions.activeItemRequest(activeData));
      event.stopPropagation();
      const unitOperationType = activeData && activeData.operation_type && activeData.operation_type.lookupItemName;
      const unitOperationTypeList = ['Sale', 'Rent', 'SaleAndRent'];
      if (actionEnum === ActionsEnum.folder.key) {
        if (unitOperationType === unitOperationTypeList[0]) {
          GlobalHistory.push(
            `/home/units-sales/unit-profile-edit?formType=${activeData.unitTypeId}&id=${activeData.id}`
          );
        } else if (unitOperationType === unitOperationTypeList[1]) {
          GlobalHistory.push(
            `/home/units-lease/unit-profile-edit?formType=${activeData.unitTypeId}&id=${activeData.id}`
          );
        } else if (unitOperationType === unitOperationTypeList[2]) {
          GlobalHistory.push(
            `/home/units-sales/unit-profile-edit?formType=${activeData.unitTypeId}&id=${activeData.id}`
          );
        } else {
          GlobalHistory.push(
            `/home/units/unit-profile-edit?formType=${activeData.unitTypeId}&id=${activeData.id}`
          );
        }
      } else if (actionEnum === ActionsEnum.matching.key) {
        GlobalHistory.push(
          `/home/units-sales/unit-profile-edit?formType=${activeData.unitTypeId
          }&id=${activeData.id}&operationType=${activeData.operationType
          }&matching=${true}`);
      }
    }, [dispatch, pathName]);

  const onPageIndexChanged = (pageIndex) => {
    setFilter((item) => ({ ...item, pageIndex }));
  };
  const onPageSizeChanged = (pageSize) => {
    setFilter((item) => ({ ...item, pageIndex: 0, pageSize }));
  };
  useEffect(() => {
    bottomBoxComponentUpdate(
      <PaginationComponent
        pageIndex={filter.pageIndex}
        pageSize={filter.pageSize}
        totalCount={unitsDetailes && unitsDetailes.totalCount}
        onPageIndexChanged={onPageIndexChanged}
        onPageSizeChanged={onPageSizeChanged}
      />
    );
  }, [filter, unitsDetailes]);

  useEffect(
    () => () => {
      bottomBoxComponentUpdate(null);
    },
    []
  );
  const focusedRowChanged = useCallback(() => { }, []);

  useEffect(() => {
    if (operationType) getPropertyUnits();
  }, [getPropertyUnits]);

  useEffect(() => {
    if (sortBy)
      setOrderBy((item) => ({ ...item, filterBy: sortBy.filterBy && sortBy.filterBy[0].toLowerCase() + sortBy.filterBy.slice(1), orderBy: sortBy.orderBy, fieldType: sortBy.fieldType }));
  }, [sortBy]);

  return (
    <div className="associated-Properties-wrapper">
      <Spinner isActive={isLoading} />
      <div className="title-section d-flex-v-center-h-between flex-wrap m-3">
        <div className="px-2">
          <div className="d-flex-column-center">
            <span>{t(`${translationPath}sale-units`)}</span>
            <ButtonBase
              className="btn  btns theme-solid mt-2 mb-2"
              style={{ backgroundColor: "#368750e3" }}
              onClick={() => createNewUnitHandler()}
            >
              <span className="mdi mdi-arrow" />
              <span className="px-1">
                {t(`${translationPath}add-new-unit`)}
              </span>
            </ButtonBase>
          </div>
        </div>
        {/* Filter row like lease units */}
        <div className="filters-row d-flex flex-row align-items-center justify-content-between w-100 py-2 px-2" style={{ background: '#f8f9fa', borderRadius: '8px' }}>
          <div className="d-flex flex-row align-items-center" style={{ gap: '8px' }}>
            <SelectComponet
              data={Object.values(UnitsFilterStatusEnum.sale)}
              emptyItem={{
                value: 0,
                text: "Select Status",
                isDisabled: true,
                isHiddenOnOpen: true,
              }}
              value={unitStatus}
              valueInput="value"
              textInput="display"
              multiple
              onSelectChanged={(value) => {
                if (value?.length > 1) {
                  value = value.filter((item) => !!item);
                } else if (value?.length === 0) {
                  value = [0];
                }
                setUnitStatus(value);
              }}
              wrapperClasses="w-auto"
              themeClass="theme-default"
              idRef="Unit_Status"
              parentTranslationPath={parentTranslationPath}
              translationPath={translationPath}
              translationPathForData={translationPath}
            />
            <SelectComponet
              data={[{ key: 1, name: "published" }, { key: 2, name: "unpublished" }]}
              emptyItem={{ value: 0, text: "Select Unit Publish", isDisabled: false }}
              value={unitPublishStatus || 0}
              valueInput="key"
              textInput="name"
              onSelectChanged={(value) => setUnitPublishStatus(value)}
              wrapperClasses="w-auto"
              themeClass="theme-default"
              idRef="Select_Unit_Publish"
              parentTranslationPath={parentTranslationPath}
              translationPath={translationPath}
              translationPathForData={translationPath}
            />
            <Inputs
              value={bedrooms}
              onKeyUp={(e) => setBedrooms(e.target.value)}
              idRef="bedroomsSearchRef"
              labelClasses="mt-0"
              onInputChanged={(e) => setBedrooms(e.target.value)}
              inputPlaceholder={t(`${translationPath}Bedrooms Filter`)}
              wrapperClasses="w-auto"
              style={{ minWidth: '120px' }}
            />
            <Inputs
              value={bathrooms}
              onKeyUp={(e) => setBathrooms(e.target.value)}
              idRef="bathroomsSearchRef"
              labelClasses="mt-0"
              onInputChanged={(e) => setBathrooms(e.target.value)}
              inputPlaceholder={t(`${translationPath}Bathrooms Filter`)}
              wrapperClasses="w-auto"
              style={{ minWidth: '120px' }}
            />
            <Inputs
              idRef="activitiesSearchRef"
              inputPlaceholder={t(`${translationPath}UnitNumber`)}
              inputRef={unitNumberInputRef}
              value={unitNumber}
              onInputChanged={(e) => setUnitNumber(e.target.value)}
              onKeyUp={(e) => {
                const value = e?.target?.value;
                if (searchTimer.current) clearTimeout(searchTimer.current);
                searchTimer.current = setTimeout(() => {
                  getPropertyUnits(value);
                }, 1200);
              }}
              wrapperClasses="w-auto"
              style={{ minWidth: '120px' }}
            />
          </div>
          <div className="" style={{ display: 'flex', gap: '16px', marginLeft: 'auto' }}>
            <ButtonBase
              className="btn btns theme-solid"
              onClick={() => {
                setUnitStatus([0]);
                setUnitPublishStatus(0);
                setBedrooms("");
                setBathrooms("");
                setUnitNumber("");
                getPropertyUnits();
              }}
            >
              {t(`${translationPath}Reset Filters`)}
            </ButtonBase>
            <div>
              <ViewTypes
                initialActiveType={viewType}
                onTypeChanged={onTypeChanged}
                activeTypes={[ViewTypesEnum.tableView.key, ViewTypesEnum.cards.key]}
              />
            </div>
          </div>
        </div>
      </div>
      {viewType === ViewTypesEnum.tableView.key && (
        <div className="w-100 px-2">
          <Tables
            data={unitsDetailes.result}
            headerData={[
              {
                id: 1,
                isSortable: true,
                label: "Unit Id",
                input: "unitId",
                isNumber: true,
                component: (item) => item.id || <span />,
              },
              {
                id: 2,
                isSortable: true,
                label: "Unit Type",
                input: "unit_type",
                component: (item) =>
                  item.unitType && <span> {item.unitType}</span>,
              },
              {
                id: 3,
                isSortable: true,
                label: "Operation Type",
                input: "operation_type.lookupItemName",
                component: (item) =>
                  item &&
                  item.unitOperationType && (
                    <span> {item.unitOperationType}</span>
                  ),
              },

              {
                id: 4,
                isSortable: true,
                label: "Sale Unit Status",
                input: "stringStatus",
                component: (item) =>
                  item &&
                  item.unitStatus &&
                  item.unitStatus.name && <span> {item.unitStatus.name}</span>,
              },
              {
                id: 6,
                isSortable: true,
                label: "Owner Name",
                input: "lead_owner.name",
                component: (item) =>
                  item &&
                  item.owner && (
                    <span>
                      {" "}
                      {item.owner.map((item) => (item ? `${item}` : ""))}
                    </span>
                  ),
              },
              {
                id: 7,
                isSortable: true,
                label: "Unit Reference no",
                input: "unit_ref_no",
                component: (item) =>
                  item && item.unit_ref_no && <span> {item.unit_ref_no}</span>,
              },
              {
                id: 8,
                isSortable: true,
                label: "Listing Agent",
                input: "listing_agent",
                component: (item) =>
                  item?.listing_agent?.name && (
                    <span> {item.listing_agent.name}</span>
                  ),
              },
              {
                id: 9,
                isSortable: true,
                label: "Rent Listing Agent",
                input: "rent_listing_agent",
                component: (item) =>
                  item?.rent_listing_agent?.name && (
                    <span> {item.rent_listing_agent.name}</span>
                  ),
              },
              {
                id: 10,
                isSortable: true,
                label: "Unit Number",
                input: "unit_number",
                component: (item) =>
                  item.unit_number && <span> {item.unit_number}</span>,
              },
            ]}
            setSortBy={setSortBy}
            onPageIndexChanged={onPageIndexChanged}
            onPageSizeChanged={onPageSizeChanged}
            actionsOptions={{
              onActionClicked: tableActionClicked,
            }}
            defaultActions={[
              {
                enum: TableActions.openFile.key,
                isDisabled: pathName === "property",
              },
            ]}
            itemsPerPage={filter.pageSize}
            activePage={filter.pageIndex}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            focusedRowChanged={focusedRowChanged}
            totalItems={
              unitsDetailes && unitsDetailes.totalCount
                ? unitsDetailes.totalCount
                : 0
            }
          />
        </div>
      )}
      {viewType === ViewTypesEnum.cards.key &&
        unitsDetailes &&
        unitsDetailes.result && (
          <UnitsCardsComponent
            data={unitsDetailes}
            translationPath={translationPath}
            parentTranslationPath={parentTranslationPath}
            displyMatchingButton
            displyOpenFileButton
            onFooterActionsClicked={detailedCardSideActionClicked}
          />
        )}
    </div>
  );
}
